import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { firmInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-[#1a1c1b] border-t border-[#3f4816]/30">
      <div className="container mx-auto px-6 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* About */}
          <div>
            <h3 className="text-[#d9fb06] text-xl font-bold mb-4">{firmInfo.name}</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Professional legal services in Nairobi. Committed to integrity, client satisfaction, and delivering exceptional results.
            </p>
            <div className="flex items-center space-x-2">
              <div className="flex text-[#d9fb06]">
                {[...Array(5)].map((_, i) => (
                  <span key={i}>★</span>
                ))}
              </div>
              <span className="text-gray-400 text-sm">{firmInfo.rating} Rating</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[#d9fb06] text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#d9fb06] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#d9fb06] transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/practice-areas" className="text-gray-400 hover:text-[#d9fb06] transition-colors text-sm">
                  Practice Areas
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#d9fb06] transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-[#d9fb06] text-xl font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-[#d9fb06] mt-0.5 flex-shrink-0" />
                <a href={`tel:${firmInfo.phone}`} className="text-gray-400 hover:text-[#d9fb06] transition-colors text-sm">
                  {firmInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#d9fb06] mt-0.5 flex-shrink-0" />
                <a href={`mailto:${firmInfo.email}`} className="text-gray-400 hover:text-[#d9fb06] transition-colors text-sm">
                  {firmInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#d9fb06] mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{firmInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#3f4816]/30 mt-12 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} {firmInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
